import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useEffect, useState } from "react";
import { deleteDocuments } from "../../api/simpleSearchApi/simpleSearchApi";
import { useLoader } from "../../context/LoaderContext";
import { DeleteFiles } from "../../api/preworkDetailApi/preworkDetailApi";
import { useSnackbar } from "../Common/SnackbarContext";

interface ConfirmationAlertProps {
  isOpen: boolean;
  onClose: (isCancelClick: boolean) => void;
  title: string;
  selectedData: any;
  isArf: boolean;
  screen: string;
}

const ConfirmationAlert: React.FC<ConfirmationAlertProps> = ({
  isOpen,
  onClose,
  title,
  selectedData,
  isArf,
  screen,
}) => {
  const [confirmationMessage, setConfirmationMessage] = useState<string>("");
  const { setLoading } = useLoader();
  const { showSnackbar } = useSnackbar();

  //Handle dialog close
  const handleDialogClose = (confirm: boolean) => {
    onClose(confirm);
  };

  //Handle Yes
  const handleYes = async () => {
    try {
      setLoading(true);
      if (screen.toLowerCase() === "preworkdetails") {
        const response = await DeleteFiles(selectedData);
        if (response) {
          showSnackbar("Documents deleted successfully");
        } else {
          showSnackbar("Unable to delete file", true);
        }
      } else {
        const response = await deleteDocuments(selectedData);
        if (response.status === 200) {
          showSnackbar("Documents deleted successfully");
        } else {
          showSnackbar("Unable to delete file");
        }
      }
      onClose(true);
    } catch (error) {
      console.log("Error deleting documents. Please try again.");
    } finally {
      handleDialogClose(false);
      setLoading(false);
    }
  };

  //Set dialog confirmation message on open dialog box
  useEffect(() => {
    if (isOpen) {
      setDialogConfirmationMessage();
    }
  }, [isOpen]);

  //Set dialog confirmation message
  const setDialogConfirmationMessage = () => {
    if (isArf) {
      setConfirmationMessage(
        "The record selected contain A records.If deleted these will leave associated ARF Records Orphaned. Are you sure you want to continue?"
      );
    } else {
      setConfirmationMessage(
        "Are you sure you want to delete the selected document(s)?"
      );
    }
    setLoading(false);
  };

  //Rendering confirmation alert dialog box
  return (
    <Dialog open={isOpen} onClose={() => handleDialogClose(false)}>
      <DialogTitle
        style={{
          backgroundColor: "var(--primary-color)",
                  color: "var(--aggrid-text-color)",
                  fontSize: "16px", 
                  fontWeight: 500, 
                  padding: "12px 16px", 
                  display: "flex",
                  alignItems: "center",
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent style={{ fontSize: "12px", marginTop: "20px",  padding: "1px 24px"  }}>{confirmationMessage}</DialogContent>
      <DialogActions>
        <Button
           style={{ fontSize: "14px", height: "2.1em", padding: "4px 6px",border: "1px solid #144979", }}
          onClick={() => handleYes()}
          color="primary"
        >
          Yes
        </Button>
        <Button
          style={{ fontSize: "14px", height: "2.1em", padding: "4px 6px",border: "1px solid #144979", }}
          onClick={() => handleDialogClose(false)}
          
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationAlert;
